import React from 'react';

/**
 * Reusable detail page header with back button, title, and chevron navigation.
 *
 * Props:
 *   title       – h1 text
 *   onBack      – called when back button is clicked
 *   backLabel   – text for the back link (default "← Back")
 *   onPrev      – navigate to previous item
 *   onNext      – navigate to next item
 *   canPrev     – boolean, whether prev is available
 *   canNext     – boolean, whether next is available
 *   prevTitle   – hover title for prev button
 *   nextTitle   – hover title for next button
 *   actions     – ReactNode for right-side action buttons
 *   children    – content below the header (info card, etc.)
 */
export default function DetailPageHeader({
  title,
  onBack,
  backLabel = '← Back',
  onPrev,
  onNext,
  canPrev = false,
  canNext = false,
  prevTitle,
  nextTitle,
  actions,
  children,
}) {
  return (
    <div className="detail-header">
      {onBack && (
        <button className="btn-back" onClick={onBack}>
          {backLabel}
        </button>
      )}

      <div className="detail-header-top">
        <h1>{title}</h1>

        <div className="header-actions">
          {(onPrev || onNext) && (
            <div className="nav-chevrons">
              {canPrev ? (
                <button
                  className="nav-chevron"
                  onClick={onPrev}
                  title={prevTitle}
                >
                  ‹
                </button>
              ) : (
                <span className="nav-chevron-hidden">‹</span>
              )}
              {canNext ? (
                <button
                  className="nav-chevron"
                  onClick={onNext}
                  title={nextTitle}
                >
                  ›
                </button>
              ) : (
                <span className="nav-chevron-hidden">›</span>
              )}
            </div>
          )}
          {actions}
        </div>
      </div>

      {children}
    </div>
  );
}
